import { GetStaticPropsContext, GetStaticPropsResult } from 'next'

import { PrivacyPolicy } from '@/modules/termsAndPrivacy/pages/PrivacyPolicy'

export async function getStaticProps(
  _: GetStaticPropsContext,
): Promise<GetStaticPropsResult<{}>> {
  return {
    props: {},
  }
}

export default PrivacyPolicy
